module.exports = __webpack_public_path__ + "img/doc.5e9f7af1.svg";